import React, {PureComponent} from 'react'
import cn from "classnames"
import PropTypes from 'prop-types'
import {UnstyledLink} from "./Link"
import injectStyles from "react-jss"

class LinkButton extends PureComponent {
    render() {
        const {classes, theme, className, loading, ...rest} = this.props;
        return <UnstyledLink {...rest} className={cn(classes.link, className, loading && classes.active)} />
    }
}


LinkButton.propTypes = {
    link: PropTypes.object,
    onClick:PropTypes.func,
    target: PropTypes.string,
    className: PropTypes.string,
    activeClassName: PropTypes.string,
    style: PropTypes.object,
    track: PropTypes.object,
}

export default injectStyles((theme) => ({
    link: {
        ...theme.font.linkButton,
        padding: `0.4rem 1.2rem`,
        letterSpacing: '1.4px',
        textDecoration: "none",
        borderWidth: 1,
        borderColor: theme.colors.faintGrey,
        borderRadius: '3px',
        borderStyle: "solid",
        transition: `background-color 0.2s ${theme.animation.easing.standardCurve}`,
        lineHeight: "1rem",
        display: 'inline-block',
        "&:hover": {
          color: theme.colors.white,
          backgroundColor: theme.colors.lightBlue,
          borderColor: theme.colors.borderBlue
        },
        "&:active": {
          color: theme.colors.white,
          backgroundColor: theme.colors.activeBlue,
          borderColor: theme.colors.borderBlue
        },
        "&.disabled": {
          background: theme.colors.lightGrey,
          color: theme.colors.white,
          border: 'none',
          cursor: 'not-allowed'
        }
    },
    active: {
      color: theme.colors.white,
      backgroundColor: theme.colors.activeBlue,
      borderColor: `${theme.colors.borderBlue} !important`
    }
}))(LinkButton)





// WEBPACK FOOTER //
// ./src/components/Widgets/LinkButton.js